module.exports = __webpack_public_path__ + "img/operations.9a09b495.svg";